import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private _storage: Storage | null = null;
  private _initPromise: Promise<void>;

  constructor(private storage: Storage) {
    this._initPromise = this.init();
  }

  async init() {
    // If using, define drivers here: await this.storage.defineDriver(/*...*/);
    const storage = await this.storage.create();
    this._storage = storage;
  }

  async ready() {
    await this._initPromise;
  }

  // Create methods
  async set(key: string, value: any) {
    await this.ready();
    await this._storage?.set(key, value);
  }

  // Read methods
  async get(key: string) {
    await this.ready();
    return await this._storage?.get(key);
  }

  // Remove methods
  async remove(key: string) {
    await this.ready();
    await this._storage?.remove(key);
  }

  // Clear methods
  async clear() {
    await this.ready();
    await this._storage?.clear();
  }

  // Get all keys
  async keys() {
    await this.ready();
    return await this._storage?.keys();
  }
}
